import React, {Component} from 'react';
import './Home.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import {input} from "antd";
import {Label, UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../common/validation";

class CertificateVerification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            isLoading: false,
            tcKimlikNo: null,
            barcode: null,
            result: null
        };
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.checkValidity = this.checkValidity.bind(this);
        this.onChangeTckn = this.onChangeTckn.bind(this);
        this.onChangeBarcode = this.onChangeBarcode.bind(this);

    }

    onChangeTckn(e) {
        let value = e.target.value.replace(/[^\d]+/g, '');
        this.setState({tcKimlikNo: value, result: null});
    }

    onChangeBarcode(e) {
        let value = e.target.value.toLocaleUpperCase();
        this.setState({barcode: value, result: null});
    }

    checkValidity() {
        let self = this;
        self.setState({
            isLoading: true,
            result: null
        });

        let validity = self.validateComponent();

        let params = {
            url: API_BASE_URL + "/uye/check-certificate-validity",
            method: 'post',
            data: {
                barcode: this.state.barcode,
                tcKimlikNo: this.state.tcKimlikNo
            }
        };

        if (validity.valid) {
            request(params).then(function (response) {
                let result = response.data;
                self.setState({
                    result,
                    isLoading: false,
                });
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({
                    isLoading: false,
                });
            });
        }
    }


    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    render() {

        return (
            <div className="home-container center col-sm-6">
                {(this.state.isLoading) && <div className="loader"><LoadingIndicator/></div>}
                <div className="page-content col-sm-12">
                    <img src={process.env.REACT_APP_CONTEXT_NAME + "/image/oda.png"} alt='oda-logo'
                         className='ogo-login-logo'/>
                    <div className="row col-sm-12 center">
                        <Label className="col-sm-12"
                               style={{fontSize: "14px", color: "rgb(18 75 132)", fontWeight: "bold"}}>
                            ŞanlıUrfa Eczacı Odası Belge Doğrulama Sayfasına Hoş Geldiniz.<br/>
                            Verilen Bilgiler Yalnızca Doğrulama Amaçlıdır!
                        </Label>
                        <div className={"col-sm-12 form-group" + this.validateClass('tTckNo')}>
                            <input className="form-control"
                                   type="text"
                                   name="tckNo"
                                   id="tTckNo"
                                   maxLength="11"
                                   placeholder="TC Kimlik No Giriniz"
                                   data-vlength="11"
                                   onBlur={() => this.validateField({
                                       target: {
                                           id: "tTckNo",
                                           dataset: {vdata: "identifier", vlength: '11'},
                                           value: this.state.tcKimlikNo
                                       }
                                   })}
                                   ref="tTckNo"
                                   value={this.state.tcKimlikNo}
                                   onChange={(e) => this.onChangeTckn(e)}/>
                            {this.validateMessage('tTckNo') !== "" &&
                            <UncontrolledTooltip placement="right" target="tTckNo" delay={0}>
                                {this.validateMessage("tTckNo")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                    <div className="row col-sm-12">
                        <div className={"col-sm-12 form-group" + this.validateClass('tBarcode')}>
                            <input className="form-control"
                                   type="barcode"
                                   name="barcode"
                                   id="tBarcode"
                                   maxLength="8"
                                   data-vlength="8"
                                   placeholder="Doğrulama Kodu Giriniz"
                                   onBlur={this.validateField}
                                   ref="tBarcode"
                                   value={this.state.barcode}
                                   onChange={(e) => this.onChangeBarcode(e)}/>
                            {this.validateMessage('tBarcode') !== "" &&
                            <UncontrolledTooltip placement="right" target="tBarcode" delay={0}>
                                {this.validateMessage("tBarcode")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                    {this.state.result &&
                    <Label className="col-sm-12"
                           style={{fontSize: "12px", color: "rgb(49 99 18)", fontWeight: "bold"}}>
                        {this.state.result}
                    </Label>
                    }
                    <div className="col-sm-12">
                        <button onClick={() => {
                            this.checkValidity()
                        }}
                                className="certificate-validate-button col-sm-8"
                                disabled={this.state.isLoading || (!this.state.barcode || this.state.barcode.length !== 8) || (!this.state.tcKimlikNo || this.state.tcKimlikNo.length !== 11)}
                        >BELGEYİ DOĞRULA
                        </button>
                    </div>
                </div>
            </div>

        );
    }

}


export default CertificateVerification;



// WEBPACK FOOTER //
// ./src/page/home/CertificateVerification.js